const addSpaces = (number) => {
    if (number) {
      let integ = number ? number.toString().replace(/[^\d]/g, '').split('').reverse().join('') : '';
      const matches = integ.match(/.{1,3}/g);
      integ = integ !== '' ? matches.join(' ') : '';

      number = integ.split('').reverse().join('');
      return number;
    } else {
        return '0';
    }
};

export default addSpaces;
